import type { FavoritedHotel } from '@/interfaces/api/v1-hotel-list';
import emitter from 'tiny-emitter/instance';

type EventMap = {
	'Autocomplete:updatedActiveItem': () => void;
	'BannerTop:Close': () => void;
	'bookmark:favoriteChange': (iffCode: number, added: boolean) => void;
	'bookmark:hotelsUpdated': (hotels: FavoritedHotel[]) => void;
	'Calendar:Scroll': () => void;
	'CheckoutInfoBoxStatus:OpenBookOnRequestModal': () => void;
	'CheckoutPersonalDataForm:BirthdayChange': () => void;
	'Destination:OpenQuickPills': () => void;
	'FilterModal:submit': () => void;
	'HotelOnly:Change': (isHotelOnly: boolean) => void;
	'hotel:openMap': () => void;
	lastModalClosed: () => void;
	loadDefaultAutosuggests: () => void;
	'OfferDuration:ModalClose': () => void;
	'OfferDurationField:OpenTravelDuration': () => void;
	'OfferSearch:ScrollUpSearchForm': () => void;
	'search:submit': (value?: boolean) => void;
	'search-form:storeInitialized': () => void;
	'SearchMask:MobileSubmit': () => void;
	'Store:Initialized': () => void;
	'ThemePageSearch:openSearch': () => void;
	'TravelDuration:Changed': () => void;
	'url:change': () => void;
	'window:popstate': (state: PopStateEvent['state']) => void;
	'window:resize': (event: Event) => void;
	[k: `keydown.${string}`]: () => void;
};

type EventKey = keyof EventMap;
type EventCallback<K extends EventKey> = EventMap[K];

export const EventBus = {
	$on<K extends EventKey>(event: K, callback: EventCallback<K>) {
		emitter.on(event, callback);
	},
	$once<K extends EventKey>(event: K, callback: EventCallback<K>) {
		emitter.once(event, callback);
	},
	$off<K extends EventKey>(event: K, callback?: EventCallback<K>) {
		emitter.off(event, callback);
	},
	$emit<K extends EventKey>(event: K, ...args: Parameters<EventCallback<K>>) {
		emitter.emit(event, ...args);
	},
};
